
import { Component, Prop, Mixins } from 'vue-property-decorator';
import {
  Dialog,
  Form,
  FormItem,
  DatePicker,
  Input,
  Button,
  Select,
  Option,
} from 'element-ui';
import { IContract } from '@/types/org.d';
import FormMixin from './formMixin';

@Component({
  components: {
    Dialog,
    Form,
    FormItem,
    DatePicker,
    Input,
    Button,
    Select,
    Option,
  },
})
export default class ManageBusModal extends Mixins(FormMixin) {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean;

  @Prop({
    required: false,
    default: '试卷分配',
  }) title!: string;

  @Prop({
    required: false,
  }) oldForm!: IContract;

  mounted() {
    if (this.title.includes('编辑')) this.form = Object.assign({}, this.oldForm);
    this.form.orgPid = Base64.decode(this.$route.params.pid || '');
    this.getExamList();
  }

  // 重置表单
  reset(close: boolean = false, refrsh: boolean = false) {
    if (close) this.$emit('update:visible', false);
    if (refrsh) this.$emit('refrsh');
    this.$log({
      title: `${this.log.name}${close ? '关闭' : '重置'}`,
      component: this.log.component,
    });
    this.resetForm();
  }
}
